<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Permissions />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Permissions from "../../components/GestionEmpleados/Views/Employee/Permissions.vue";
export default {
  components: { LandingToolbar, Permissions },
};
</script>
